module.exports = "<h1>Customer Configuration</h1>"